import React, { Component } from "react";
import { connect } from "react-redux";

import {
  BarChart,
  Bar,
  Tooltip,
  ResponsiveContainer,
  XAxis,
  ReferenceLine,
} from "recharts";

import Loader from "../Loader/Loader.js";
import {
  Metric,
  selectFormat,
  ComponentWithUrl,
  Error,
} from "components/Utils/Utils.js";
import Heading from "../Elements/Heading.js";

class CustomToolTip extends Component {
  showLabels = (payload) => {
    let labels = Object.keys(payload).map(function (key) {
      return (
        <p className="label" key={key}>
          {payload[key].payload.fullName}:{" "}
          <span className="value">
            {selectFormat("number", payload[key].value)}{" "}
          </span>
        </p>
      );
    });

    return labels;
  };

  render() {
    const { active } = this.props;

    if (active) {
      const { payload } = this.props;
      if (payload && payload.length > 0) {
        return <div className="custom-tooltip">{this.showLabels(payload)}</div>;
      }
    }

    return null;
  }
}

class AdsSummary extends ComponentWithUrl {
  render() {
    const { loading, data } = this.props;

    if (loading) {
      return <Loader minHeight={400} col={"col-12"} />;
    }

    if (data.hasData === false) {
      return <Error minHeight={360} />;
    }

    return (
      <div className="col-12">
        <div className="widget">
          <header className="widget__header">
            <h5 className="widget__title">{this.props.title}</h5>
          </header>

          <div className="row">
            <div className="col-12 col-md-6">
              <div className="row">
                <div className="col-8">
                  <Heading size={6} className={"mb-1"}>
                    {data.key_acquisition_metric_name}
                  </Heading>
                  <Metric
                    {...data.overall_summary.email__successes_last7}
                    size={"lg"}
                  />
                </div>
                <div className="col-4">
                  <Heading size={6} className={"mb-1"}>
                    Previous 7 Days
                  </Heading>
                  <Metric
                    {...data.overall_summary.email__successes_previous7}
                    size={"md"}
                  />
                </div>
              </div>

              <div className="row">
                <div className="col-8">
                  <Heading size={6} className={"mb-1"}>
                    Overall CPA Last 7 Days
                  </Heading>
                  <Metric
                    {...data.overall_summary.cpa_last7}
                    size={"lg"}
                    type={"currency"}
                  />
                </div>
                <div className="col-4">
                  <Heading size={6} className={"mb-1"}>
                    Previous 7 Days
                  </Heading>
                  <Metric
                    {...data.overall_summary.cpa_previous7}
                    size={"md"}
                    type={"currency"}
                  />
                </div>
              </div>
            </div>

            <div className="col-12 col-md-6 mt-md-0 mt-3">
              <Heading size={6} className={"mb-3"}>
                {data.key_acquisition_metric_name}
              </Heading>

              <div className="row">
                <div className="col-4">
                  <h6 className="widget__metric-label">Yesterday</h6>
                  <Metric value={data.overall_summary.yesterday} size={"md"} />
                </div>
                <div className="col-4">
                  <h6 className="widget__metric-label">Last 30 Days</h6>
                  <Metric value={data.overall_summary.last30} size={"md"} />
                </div>
                <div className="col-4">
                  <h6 className="widget__metric-label">Year-To-Date</h6>
                  <Metric value={data.overall_summary.ytd} size={"md"} />
                </div>
              </div>

              <ResponsiveContainer height={100} width="100%">
                <BarChart
                  width={150}
                  height={100}
                  data={data.overall_summary_by_month}
                  margin={{
                    top: 0,
                    right: 0,
                    left: 0,
                    bottom: 0,
                  }}
                  barSize={40}
                >
                  <Tooltip
                    content={<CustomToolTip />}
                    cursor={{ fill: "#eee", opacity: 0.5 }}
                  />
                  <defs>
                    <linearGradient id="colorUv" x1="0" y1="0" x2="0" y2="1">
                      <stop offset="5%" stopColor="#FAA461" stopOpacity={1} />
                      <stop offset="95%" stopColor="#FC6D52" stopOpacity={1} />
                    </linearGradient>
                  </defs>
                  <Bar dataKey="count" fillOpacity={1} fill="url(#colorUv)" />
                  <XAxis
                    dataKey="name"
                    axisLine={false}
                    tickLine={false}
                    tick={{
                      strokeWidth: 0,
                      fill: "#25263F",
                    }}
                  />
                  <ReferenceLine
                    y={data.overall_summary_chart_reference.y}
                    strokeDasharray="3 3"
                    stroke="#FC6D52"
                    ifOverflow="extendDomain"
                  />
                </BarChart>
              </ResponsiveContainer>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, props) => {
  const myState = state.data[props.url];
  return {
    data: myState ? myState.data : null,
    loading: myState ? myState.loading : true,
  };
};

export default connect(mapStateToProps)(AdsSummary);
